'use client';
import { Link } from '@fshr/components';
import { useTranslations } from '@fshr/context/i18n-context';

export default function SkipToMain() {
	const t = useTranslations();
	return (
		<Link
			intent="outline"
			onClick={event => {
				event.currentTarget.blur();
			}}
			className="fixed top-0 -left-[999px] -z-[999] p-0 w-0 h-0 bg-black text-white overflow-hidden underline uppercase text-[0.625rem] tracking-[0.3em] leading-[1.3em] outline-hidden rounded-none focus:w-[250px] focus:h-[35px] focus:z-[999] focus:left-0 focus:py-100 focus:px-200 focus:bg-black focus:text-white focus:hover:bg-white focus:hover:text-black transition-colors"
			href="#main"
		>
			{t('SKIP TO MAIN CONTENT')}
		</Link>
	);
}
